import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { UsersIcon } from 'lucide-react';
export function LiveVisitors() {
  const [visitors, setVisitors] = useState(4);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const interval = window.setInterval(() => {
      setVisitors(current => {
        const next = current + (Math.random() > 0.5 ? 1 : -1);
        return Math.min(Math.max(next, 3), 8);
      });
    }, 5000);
    return () => window.clearInterval(interval);
  }, []);
  return <div className="inline-flex items-center gap-2 rounded-full border border-green-500/30 bg-boxing-dark px-3.5 py-2 text-xs font-bold text-green-400 shadow-[0_0_18px_rgba(34,197,94,0.08)]" aria-live="polite" aria-label={`${visitors} personas viendo esta página ahora`} data-id="element-133">
      <span className="relative flex h-2 w-2" aria-hidden="true" data-id="element-134">
        {!reduceMotion && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-60" data-id="element-135" />}
        <span className="relative inline-flex h-2 w-2 rounded-full bg-green-500" data-id="element-136" />
      </span>
      <UsersIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-137" />
      <span data-id="element-138">
        <motion.span key={visitors} initial={reduceMotion ? false : {
        opacity: 0,
        y: -5
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: reduceMotion ? 0 : 0.2
      }} className="inline-block font-black" data-id="element-139">
          {visitors}
        </motion.span>{' '}
        personas viendo esto ahora
      </span>
    </div>;
}